import { Modal } from "@forge/bridge";

import { MODAL_IDS } from "./consts";

export const openCatalogBrowser = ({
  catalog,
  generalStyling = {},
  openCart = false,
  openPreviewCart = false,
  cart,
  onClose,
  customSelection = undefined,
}) => {
  new Modal({
    resource: "catalog-browser-modal",
    onClose: (payload) => {
      /*      const { isClosedFromCheckout, ...rest } = payload || {};
      return onClose(
        isClosedFromCheckout
          ? { ...rest, catalogId: cart.catalogId }
          : { ...cart }
      ); */
    },
    size: "max",
    closeOnEscape: true,
    closeOnOverlayClick: true,
    context: {
      catalog,
      cart,
      generalStyling,
      openCart,
      openPreviewCart,
      customSelection,
    },
  }).open();
};

export const openImportSchemaModal = ({ catalogId, onClose }) => {
  new Modal({
    onClose: (payload) => {
      const { categoriesToAdd } = payload || {};
      if (!categoriesToAdd) return;
      onClose(categoriesToAdd);
    },
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "configuration-modal",
    size: "large",
    context: {
      modalId: "import-schema-modal",
      catalogId,
    },
  }).open();
};

export const openDeleteCatalogModal = ({ catalog: { id, name }, onClose }) => {
  new Modal({
    onClose: (isDeleted) => {
      if (isDeleted) onClose();
    },
    size: "small",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "confirmation-modal",
    context: {
      modalId: "delete-catalog-modal",
      catalog: { id, name },
    },
  }).open();
};

export const openEditOrderModal = ({ payload, onClose }) => {
  new Modal({
    onClose: (isEdited) => {},
    size: "large",
    closeOnEscape: false,
    resource: "confirmation-modal",
    context: {
      modalId: MODAL_IDS.EDIT_ORDER_MODAL,
      ...payload,
    },
  }).open();
};

export const openOrderReceivedModal = ({ payload, onClose }) => {
  new Modal({
    onClose: (isEdited) => {
      if (isEdited) onClose();
    },
    size: "small",
    closeOnEscape: false,
    resource: "confirmation-modal",
    context: {
      modalId: MODAL_IDS.ORDER_RECEIVED_MODAL,
      ...payload,
    },
  }).open();
};

export const openApproveOrderModal = ({ payload, onClose }) => {
  new Modal({
    onClose: (isEdited) => {
      if (isEdited) onClose();
    },
    size: "small",
    closeOnEscape: false,
    resource: "confirmation-modal",
    context: {
      modalId: MODAL_IDS.APPROVE_ORDER_MODAL,
      ...payload,
    },
  }).open();
};

export const openAddToAssetsModal = ({ payload, onClose }) => {
  new Modal({
    onClose: (hasChanges) => {
      if (hasChanges) onClose();
    },
    size: "medium",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "confirmation-modal",
    context: {
      modalId: MODAL_IDS.ADD_TO_ASSETS_MODAL,
      ...payload,
    },
  }).open();
};

export const openDeletePanelModal = ({ panel: { id, name }, onClose }) => {
  new Modal({
    onClose: (isDeleted) => {
      if (isDeleted) onClose();
    },
    size: "small",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "confirmation-modal",
    context: {
      modalId: "delete-panel-modal",
      panel: { id, name },
    },
  }).open();
};

export const openRemoveAllAssetsModal = ({ onRemove }) => {
  new Modal({
    onClose: (isConfirmed) => {
      if (isConfirmed) onRemove();
    },
    size: "small",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "confirmation-modal",
    context: {
      modalId: "remove-all-assets-modal",
    },
  }).open();
};

export const openApplyDetailsModal = ({ payload, onClose }) => {
  new Modal({
    onClose: (data) => {
      if (!data?.updatedCategories) return;
      onClose(data.updatedCategories);
    },
    size: "large",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "configuration-modal",
    context: {
      modalId: "apply-layout-modal",
      ...payload,
    },
  }).open();
};

export const openCreatePanelModal = ({ panel, onClose }) => {
  new Modal({
    onClose: (shouldReload) => onClose(shouldReload),
    size: "large",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "configuration-modal",
    context: {
      modalId: "create-panel-modal",
      panel,
    },
  }).open();
};

export const openDeleteCategoryModal = ({
  catalogId,
  categories,
  categoryId,
  onClose,
}) => {
  new Modal({
    onClose: (payload) => {
      const { newCategories } = payload || {};
      if (!newCategories) return;
      onClose(newCategories);
    },
    resource: "confirmation-modal",
    size: "small",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    context: {
      modalId: "delete-category-modal",
      catalogId,
      categories,
      categoryId,
    },
  }).open();
};

export const openDuplicateCatalogModal = ({ catalog, onClose }) => {
  new Modal({
    onClose,
    resource: "confirmation-modal",
    size: "small",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    context: {
      modalId: "duplicate-catalog-modal",
      catalog,
    },
  }).open();
};

export const openAddObjectTypeModal = ({
  catalogId,
  order,
  parentId,
  onClose,
}) => {
  new Modal({
    onClose: (payload) => {
      const { newCategory } = payload || {};
      if (!newCategory) return;
      onClose(newCategory);
    },
    size: "large",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "configuration-modal",
    context: {
      modalId: "create-category-modal",
      catalogId,
      order,
      parentId,
    },
  }).open();
};

export const openCreateCatalogModal = ({
  catalog,
  isEdit = false,
  onClose,
}) => {
  new Modal({
    onClose,
    size: "large",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "configuration-modal",
    context: {
      catalogId: catalog?.id,
      isEdit,
      modalId: "create-catalog-modal",
    },
  }).open();
};

export const openCatalogBannerModal = ({ contextData = {}, onSave }) => {
  new Modal({
    onClose: (payload) => {
      const { isSaving, config, generalConfig } = payload || {};
      if (isSaving) onSave({ config, generalConfig });
    },
    size: "max",
    closeOnEscape: false,
    closeOnOverlayClick: false,
    resource: "catalog-banner-modal",
    context: {
      ...contextData,
    },
  }).open();
};

export const openPreviewBannerModal = ({ contextData = {} }) => {
  new Modal({
    onClose: () => {},
    size: "max",
    closeOnEscape: true,
    closeOnOverlayClick: true,
    resource: "previews-modal",
    context: {
      modalId: "preview-banner-modal",
      ...contextData,
    },
  }).open();
};
